/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/no-duplicates
import { format } from "date-fns";
import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";
// eslint-disable-next-line import/no-duplicates
import { ptBR } from "date-fns/locale";
import MaterialUI from "../../../../material-UI";
import warn from "../../../../constants/toast";
import handleApiError from "../../../../utils/handleApiError";
import axiosLead from "../../../../services/lead";
import * as Styles from "../../styles";

interface Props {
  idLead?: string;
  idLeadCorretor: string;
  nomeLead?: string;
  itemTask: any;
  onClose: Function;
  open: boolean;
  hotRefreshFunc: () => void;
}

interface EditTask {
  idLead: string;
  idLeadCorretor: string;
  idTipoTarefa: string;
  idEmpreendimento: string;
  nomeEmpreendimento: string;
  titulo: string;
  descricao: string;
  dataProgramadaRealizacaoTarefa: Date;
  horaProgramadaRealizacaoTarefa: Date;
  inserirTarefaNoOutlook: boolean;
  tokenAd: string;
  idTarefaLead: string;
}

const EditTaskForm: React.FC<Props> = ({
  idLead,
  idLeadCorretor,
  nomeLead,
  itemTask,
  onClose,
  open,
  hotRefreshFunc,
}) => {
  const tokenStorage = localStorage.getItem("@token");
  const parseDateTimeString = (dateTimeString: string): Date => {
    const [datePart, timePart] = dateTimeString.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hours, minutes] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hours, minutes);
  };

  const [datatask, setDataTask] = useState<Partial<EditTask>>({
    inserirTarefaNoOutlook: false,
    dataProgramadaRealizacaoTarefa: parseDateTimeString(
      itemTask.dataHoraProgramadaRealizacaoTarefa
    ),
    horaProgramadaRealizacaoTarefa: parseDateTimeString(
      itemTask.dataHoraProgramadaRealizacaoTarefa
    ),
    idLeadCorretor,
    idTipoTarefa: itemTask.idTipoTarefa,
    titulo: itemTask.titulo,
    descricao: itemTask.descricao,
    idTarefaLead: itemTask.idTarefaLead,
    idEmpreendimento: itemTask.idEmpreendimento,
    nomeEmpreendimento: itemTask.empreendimento,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [descricaoCount, setDescricaoCount] = useState<number>(
    itemTask.descricao ? itemTask.descricao.length : 0
  );
  const [tiposTarefas, setTiposTarefas] = useState([]);
  const [tiposTarefaSelected, setTipoTarefaSelected] = useState({
    nome: itemTask.tipoTarefa,
    id: itemTask.idTipoTarefa,
  });
  const [empreendimentos, setEmpreendimentos] = useState<
    Array<{ id: string; nome: string }>
  >([]);
  const [empreendimentoSelected, setEmpreendimentoSelected] = useState({
    bandeira: "",
    nome: "",
    id: "",
  });
  const [showProdutos, setShowProdutos] = useState<boolean>(false);

  useEffect(() => {
    switch (tiposTarefaSelected?.nome) {
      case "Ligação":
        return setDataTask({ ...datatask, titulo: `Ligar para ${nomeLead}` });
      case "WhatsApp":
        return setDataTask({
          ...datatask,
          titulo: `Enviar mensagem para ${nomeLead}`,
        });
      case "Agendamento de Visita":
        return setDataTask({
          ...datatask,
          titulo: `Visita agendada com ${nomeLead}`,
        });
      case "E-mail":
        return setDataTask({
          ...datatask,
          titulo: `Enviar e-mail para ${nomeLead}`,
        });
      default:
        return setDataTask({ ...datatask, titulo: "" });
    }
  }, [tiposTarefaSelected]);

  useEffect(() => {
    if (tiposTarefaSelected?.nome === "Agendamento de Visita") {
      setShowProdutos(true);
    } else {
      setShowProdutos(false);
      setEmpreendimentoSelected({ bandeira: "", nome: "", id: "" });
    }
  }, [tiposTarefaSelected]);

  useEffect(() => {
    setDataTask({ ...datatask, idTipoTarefa: tiposTarefaSelected?.id });
  }, [datatask?.titulo]);

  const createNewTask = async (e: React.FormEvent) => {
    e.preventDefault();
    if (
      datatask.dataProgramadaRealizacaoTarefa &&
      datatask.horaProgramadaRealizacaoTarefa &&
      tokenStorage
    ) {
      const formatedData = format(
        datatask?.dataProgramadaRealizacaoTarefa,
        "yyyy-MM-dd"
      );
      const formatedHora = format(
        datatask?.horaProgramadaRealizacaoTarefa,
        "HH:mm"
      );
      const token = JSON.parse(tokenStorage);
      let idEmpreendimento = null;
      if (empreendimentoSelected?.id !== "") {
        idEmpreendimento = empreendimentoSelected?.id;
      } else {
        idEmpreendimento = null;
      }
      const data = {
        ...datatask,
        dataProgramadaRealizacaoTarefa: formatedData,
        horaProgramadaRealizacaoTarefa: formatedHora,
        tokenAd: token.token,
        idEmpreendimento,
      };
      setLoading(true);
      try {
        await axiosLead.EditTask(datatask?.idTarefaLead, {
          titulo: data.titulo,
          idTipoTarefa: data.idTipoTarefa,
          idEmpreendimento: data.idEmpreendimento,
          descricao: data.descricao,
          dataProgramadaRealizacaoTarefa: data.dataProgramadaRealizacaoTarefa,
          horaProgramadaRealizacaoTarefa: data.horaProgramadaRealizacaoTarefa,
        });
        toast.success("Tarefa editada com sucesso.");
        onClose(!open);
        hotRefreshFunc();
      } catch (error: any) {
        handleApiError(error);
      }
      setLoading(false);
    }
  };

  const handleTransferComment = (comment: string) => {
    setDataTask({ ...datatask, descricao: comment });
    setDescricaoCount(comment.length);
  };

  const handleChangeData = (newValue: any) => {
    setDataTask({ ...datatask, dataProgramadaRealizacaoTarefa: newValue });
  };

  const handleChangeHora = (newValue: any) => {
    setDataTask({ ...datatask, horaProgramadaRealizacaoTarefa: newValue });
  };

  useEffect(() => {
    requestTiposTarefas();
    if (datatask.nomeEmpreendimento) {
      setEmpreendimentoSelected({
        id: "",
        nome: datatask.nomeEmpreendimento,
        bandeira: "",
      });
    } else {
      requestEmpreendimentos();
    }
  }, []);

  const requestTiposTarefas = async () => {
    try {
      const response = await axiosLead.GetTiposTarefas();
      setTiposTarefas(response.data.data);
    } catch (error: any) {
      handleApiError(error);
    }
  };

  const requestEmpreendimentos = async () => {
    try {
      const response = await axiosLead.GetEnterprises();
      const dataResponse = response.data.data;
      setEmpreendimentos(dataResponse);
      dataResponse.map((item: any) => {
        if (item.id === itemTask.idEmpreendimento) {
          setEmpreendimentoSelected(item);
        }
      });
    } catch (error: any) {
      warn.wargingError(
        `${
          error?.response?.data?.notifications?.map(
            (item: any) => `${item.message}\n`
          ) || "Erro status 500!"
        }`
      );
    }
  };

  return (
    <form
      onSubmit={(e) => createNewTask(e)}
      style={{ overflowY: "scroll", height: 500, marginBottom: 100 }}
    >
      <Styles.FieldDiv>
        <Styles.Autocomplete
          id="combo-box-demo"
          defaultValue={{
            nome: itemTask.tipoTarefa,
            id: itemTask.idTipoTarefa,
          }}
          disabled
          options={tiposTarefas}
          renderInput={(params: any) => (
            <>
              <Styles.LabelText>Tipo de tarefa *</Styles.LabelText>
              <Styles.TextField
                size="small"
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                {...params}
                label="Tipo de tarefa *"
                required
                className="input-disabled"
              />
            </>
          )}
          getOptionLabel={(option: any) => option.nome || ""}
          onChange={(event, newValue: any) => {
            setTipoTarefaSelected(newValue);
          }}
        />
      </Styles.FieldDiv>
      <Styles.FieldDiv>
        <Styles.LabelText>Título</Styles.LabelText>
        <Styles.TextField
          size="small"
          InputLabelProps={{ shrink: false }}
          variant="outlined"
          label="Título"
          fullWidth
          required
          value={datatask.titulo}
          disabled
          className="input-disabled"
          onChange={(e) => setDataTask({ ...datatask, titulo: e.target.value })}
        />
      </Styles.FieldDiv>
      {tiposTarefaSelected?.nome === "Agendamento de Visita" && (
        <Styles.TextDivider>Agendamento</Styles.TextDivider>
      )}
      <Styles.LocalizationProvider
        locale={ptBR}
        dateAdapter={MaterialUI.AdapterDateFns}
      >
        <Styles.LineRow>
          <Styles.FieldDiv style={{ width: 349, paddingRight: 8 }}>
            <Styles.DesktopDatePicker
              inputFormat="dd/MM/yyyy"
              value={datatask.dataProgramadaRealizacaoTarefa}
              onChange={(newValue: any) => handleChangeData(newValue)}
              renderInput={(params: any) => (
                <>
                  <Styles.LabelText>Data *</Styles.LabelText>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Data *"
                    fullWidth
                    required
                  />
                </>
              )}
            />
          </Styles.FieldDiv>
          <Styles.FieldDiv style={{ width: 349, paddingLeft: 8 }}>
            <Styles.TimePicker
              label="Time"
              value={datatask.horaProgramadaRealizacaoTarefa}
              onChange={(newValue: any) => handleChangeHora(newValue)}
              renderInput={(params: any) => (
                <>
                  <Styles.LabelText>Hora* </Styles.LabelText>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Hora* "
                    fullWidth
                    required
                  />
                </>
              )}
            />
          </Styles.FieldDiv>
        </Styles.LineRow>
      </Styles.LocalizationProvider>
      {showProdutos && (
        <Styles.TransferComponent>
          <Styles.Autocomplete
            id="combo-box-demo"
            defaultValue={empreendimentoSelected}
            options={empreendimentos}
            value={empreendimentoSelected}
            disabled
            renderInput={(params: any) => (
              <>
                <Styles.LabelText>Produto *</Styles.LabelText>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Produto *"
                  required
                  className="input-disabled"
                />
              </>
            )}
            getOptionLabel={(option: any) => option.nome || ""}
            onChange={(event, newValue: any) => {
              setEmpreendimentoSelected(newValue);
            }}
          />
        </Styles.TransferComponent>
      )}
      <Styles.FieldDiv>
        <Styles.MultLineField style={{ marginTop: 0 }}>
          <Styles.LabelText>Descrição</Styles.LabelText>
          <Styles.TextField
            onChange={(e: any) => handleTransferComment(e.target.value)}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            value={datatask.descricao}
            inputProps={{ maxLength: 4000 }}
          />
          <Styles.CountText>{descricaoCount}/4000</Styles.CountText>
        </Styles.MultLineField>
      </Styles.FieldDiv>
      {/* <Styles.FormControlLabel
        control={
          <Styles.Checkbox
            defaultChecked
            checked={datatask.inserirTarefaNoOutlook}
            onChange={() =>
              setDataTask({
                ...datatask,
                inserirTarefaNoOutlook: !datatask.inserirTarefaNoOutlook,
              })
            }
          />
        }
        label="Criar compromisso na agenda"
      /> */}
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button variant="outlined" onClick={() => onClose(!open)}>
            Cancelar
          </Styles.Button>
          <Styles.Button
            className="transfer-btn"
            color="secondary"
            variant="contained"
            type="submit"
            disabled={loading}
          >
            {loading ? <MaterialUI.CircularProgress /> : "Salvar"}
          </Styles.Button>
        </Styles.FooterDialog>
      </Styles.Footer>
    </form>
  );
};

export default EditTaskForm;
